module.exports = __webpack_public_path__ + "static/media/crutches.8bb08194.svg";